import { CombineComponents } from '../../utils/CombineComponents';

import { ValidateProvider } from '../../providers/ValidateProvider';
import { CreditingProvider } from '../../providers/CreditingProvider';
import { TransactionsProvider } from '../../providers/TransactionsProvider';

const providers = [
    ValidateProvider,
    CreditingProvider,
    TransactionsProvider
]

export const AppContextProvider = CombineComponents(...providers);